import {Layout} from "antd";
import {Route, Routes, Link, useNavigate, useLocation, Navigate} from "react-router-dom";
import Home from "./Home";
import Quizes from "./Quiz/Quizes";
import AppHeader from "./Fragments/AppHeader";
import Quiz from "./Quiz/Quiz";
import Wrongs from "./Wrongs/Wrongs";
import Categories from "./Categories/Categories";
import Category from "./Categories/Category";
import Descriptions from "./Descriptions/Descriptions";
import ReactGA from 'react-ga';
import {useSelector} from "react-redux";
import Descs from "./Descriptions/Descs";
import TrafficSigns from "./TrafficSigns";
import LearnRules from "./Learn/LearnRules";
import Favorites from "./Quiz/Favorites";
import PsychoTests from "./Quiz/PsychoTests";
import Search from "./Search";
import AdminChat from "./Admin/AdminChat";
import About from "./Static/About";
import Privacy from "./Static/Privacy";
import Terms from "./Static/Terms";
import ChatWidget from "./Fragments/ChatWidget";
import UserInfoModal from "./Fragments/UserInfoModal";
import QuizBattle from "./Quiz/QuizBattle";
import TonusBanner from "./Fragments/TonusBanner";

import {useTranslation} from "react-i18next";

const TRACKING_ID = "UA-235056627-1";

ReactGA.initialize(TRACKING_ID);
const { Content, Footer } = Layout;

function AppLayout(){
   const {t} = useTranslation();
   const location = useLocation();
   let {settings} =  useSelector((data) => data)

   const startAnalytics = ()=>{
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
return(
    <Layout className="layout">
        <UserInfoModal />
        <AppHeader/>
        <Content>
            <div className="site-layout-content">
                {location.pathname !== '/chat-admin' && <TonusBanner />}
                <Routes>
                    <Route path="/" element={<Home analytics={startAnalytics}/>} />
                    <Route path="/quizes" element={<Quizes analytics={startAnalytics}/>} />
                    <Route path="/quizes/:id" element={<Quiz analytics={startAnalytics}/>} />
                    <Route path="/wrongs" element={<Wrongs analytics={startAnalytics}/>} />
                    <Route path="/categories" element={<Categories analytics={startAnalytics}/>} />
                    <Route path="/categories/:id" element={<Category analytics={startAnalytics}/>} />
                    <Route path="/descriptions/" element={<Descriptions analytics={startAnalytics}/>} />
                    <Route path="/definitions/" element={<Descs analytics={startAnalytics}/>} />
                    <Route path="/traffic-signs/" element={<TrafficSigns analytics={startAnalytics}/>} />
                    <Route path="/learn/" element={<LearnRules analytics={startAnalytics}/>} />
                    <Route path="/favorites" element={<Favorites analytics={startAnalytics}/>} />
                    <Route path="/psycho" element={<PsychoTests analytics={startAnalytics}/>} />
                    <Route path="/search" element={<Search analytics={startAnalytics}/>} />
                    <Route path="/chat-admin" element={<AdminChat analytics={startAnalytics}/>} />
                    <Route path="/battle" element={<QuizBattle analytics={startAnalytics}/>} />
                    <Route path="/about" element={<About analytics={startAnalytics}/>} />
                    <Route path="/privacy" element={<Privacy analytics={startAnalytics}/>} />
                    <Route path="/terms" element={<Terms analytics={startAnalytics}/>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '10px' }}>
                <Link to="/about">{t('seo.about')}</Link> | <Link to="/privacy">{t('seo.privacy')}</Link> | <Link to="/terms">{t('seo.terms')}</Link>
            </div>
            {t('seo.created_by')} ©2026 V{settings.app_version}
        </Footer>
        {useLocation().pathname !== '/chat-admin' && <ChatWidget />}
    </Layout>
)
}
export default AppLayout;